import {
  BorderStyle,
  HeightRule,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
} from "docx";

export const firstHeadlineTable = () => {
  const factor = 0.2;
  return new Table({
    columnWidths: [7500, 2500],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        height: { value: 350, rule: HeightRule.AUTO },
        children: [
          new TableCell({
            borders: {
              top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
              right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
            },
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Vorlage einer Klausur",
                    size: 25,
                    bold: true,
                    font: "arial",
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
    ],
  });
};
